// import logo from './logo.svg';
import {API_URL, THEME_COLOR} from "../constant"
import React from 'react';
import { Link } from "react-router-dom";


class Header extends React.Component{
    render(){
        return(
            <nav className={`${THEME_COLOR} hide-on-med-and-down`}>
                <div className="nav-wrapper">
                    <a href="/" className="hide-on-med-and-down brand-logo">Miracle Houseware</a>
                    <ul id="nav-mobile" className="right hide-on-med-and-down">
                            {/* <li className="tab col s3">
                                <Link to="/" className="white-text">
                                    <i className="material-icons">home</i>
                                </Link>
                            </li> */}
                            <li className="tab col s3">
                                <Link to="/" className="white-text">
                                    <i className="material-icons">search</i>
                                </Link>
                            </li>
                            <li className="tab col s3">
                                <Link to="/cart" className="white-text">
                                    <i className="material-icons">local_grocery_store</i>
                                </Link>
                            </li>
                            <li className="tab col s3">
                                <Link to="/history" className="white-text">
                                    <i className="material-icons">assignment</i>
                                </Link>
                            </li>
                            <li className="tab col s3">
                                <Link to="/profile" className="white-text">
                                    <i className="material-icons">account_circle</i>
                                </Link>
                            </li>
                    </ul>
                </div>
            </nav>
        );
    }
}

export default Header;
